import Logo from '@/assets/images/Logo.svg';
import illustration from '@/assets/images/report/access-denied/illustration.png';

export const ReportAccessDenied = () => {
  return (
    <div className="fixed inset-0 z-[100] flex min-h-screen flex-col bg-white">
      <header className="flex h-14 items-center justify-center bg-highlight">
        <img src={Logo} alt="live." className="h-8 w-auto" />
      </header>
      <main className="flex flex-1 flex-col items-center justify-center px-6">
        <div className="relative w-[460px] max-w-full">
          <img
            src={illustration}
            alt=""
            className="pointer-events-none absolute left-1/2 top-0 h-auto w-[350px] -translate-x-1/2 object-contain"
          />
          <div className="relative px-0 pt-[248px]">
            <h1 className="text-center text-xl font-bold leading-7 text-[#0A0A0A]">
              Você não tem acesso a este report
            </h1>
            <p className="mt-2 max-w-[460px] text-center text-sm leading-6 text-[#737373]">
              Esse conteúdo é exclusivo para usuários vinculados à marca. Caso precise de acesso a
              este relatório, entre em contato com o atendimento da sua conta na Live ou com o
              suporte:
              <br />
              <a href="mailto:suporte@culturemonitor.com" className="text-[#164E63]">
                suporte@culturemonitor.com
              </a>
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};
